import { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import useStore from "../../../store"
import Spinner from "../../common/Spinner"
import CustomerSupportBranch from "./CustomerSupportBranch"
import HowToVideos from "./HowToVideos"
import InfoItem from "../../common/InfoItem"
import { liveSupportEnabled } from "../../../utilities/featureFlags"

export default function CustomerSupport() {
  const { t } = useTranslation()
  const titleCenterBranch = useStore((state) => state.titleCenterBranch)
  const fetchTitleCenterBranch = useStore((state) => state.fetchTitleCenterBranch)

  useEffect(() => {
    fetchTitleCenterBranch()
  }, [])

  return (
    <div className="flex flex-col grow items-start lg:items-center overflow-y-auto">
      <div className="w-full lg:w-2/3 text-left p-2 mb-2 bg-grey-900 rounded">
        <div className="sticky top-0 left-0 bg-grey-900">
          <h3 className="font-header font-semibold text-md text-green">{t("Support")}</h3>
        </div>
        {liveSupportEnabled && (
          <InfoItem title="Live Support">
            <Link to="/chat" className="underline">
              {t("Click here to chat with someone at Floorplan Xpress")}
            </Link>
          </InfoItem>
        )}
        <InfoItem title={t("Send Email to")}>
          <a href="mailto:dealersupport@floorplanxpress.com" className="underline hover:cursor-pointer hover:opacity-75">
            dealersupport@floorplanxpress.com
          </a>
        </InfoItem>
      </div>

      {titleCenterBranch ? (
        <>
          <CustomerSupportBranch branch={titleCenterBranch} header="Title Center" corporate={true} />
        </>
      ) : (
        <div className="flex items-center justify-center min-h-screen">
          <Spinner />
        </div>
      )}

      <HowToVideos />
    </div>
  )
}
